import { Typography, useTheme } from "@mui/material";
import moment from "moment";
import { StyledFormContainerCard } from "../../styled/form";

/**
 * Componente que muestra una lista de documentos en tarjetas con la posibilidad de seleccionar un documento.
 * @param {Array} data - Datos de los documentos a mostrar.
 * @param {Object} selectedDocument - Documento seleccionado actualmente.
 * @param {Function} changeSelectedDocument - Función para cambiar el documento seleccionado.
 * @param {Boolean} disableChange - Si es true, desactiva la selección de documentos.
 * @returns {JSX.Element}
 */

const FormContainerCards = ({
  data,
  selectedDocument,
  changeSelectedDocument,
  disableChange,
  commonProperties,
}) => {
  const theme = useTheme();
  return (
    <StyledFormContainerCard.Container>
      {data.map((document) =>
        document.permitirVisualizacion ? (
          <StyledFormContainerCard.Card
            key={document.nroFormulario}
            sx={{
              backgroundColor:
                selectedDocument.nroFormulario === document.nroFormulario
                  ? theme.palette.primary.main
                  : "",
            }}
            onClick={
              disableChange ? null : () => changeSelectedDocument(document)
            }>
            <Typography
              variant="body2"
              sx={
                selectedDocument.nroFormulario === document.nroFormulario
                  ? StyledFormContainerCard.TextActive
                  : null
              }>
              {document.nombreFormulario || document.nombre}
            </Typography>
            <StyledFormContainerCard.Date
              variant="body2"
              sx={
                selectedDocument.nroFormulario === document.nroFormulario
                  ? StyledFormContainerCard.TextActive
                  : undefined
              }>
              {moment(document.fechaHoraFormulario).format("DD/MM/YYYY")}
            </StyledFormContainerCard.Date>
          </StyledFormContainerCard.Card>
        ) : null,
      )}
    </StyledFormContainerCard.Container>
  );
};

export default FormContainerCards;
